import { render, staticRenderFns } from "./SideBarModules.vue?vue&type=template&id=2f38c522&scoped=true&"
import script from "./SideBarModules.vue?vue&type=script&lang=js&"
export * from "./SideBarModules.vue?vue&type=script&lang=js&"
import style0 from "./SideBarModules.vue?vue&type=style&index=0&id=2f38c522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38c522",
  null
  
)

export default component.exports